import Iconify from '../../../components/iconify';

const navConfig = [
  {
    title: 'dashboard',
    path: '/measure/dashboard',
    icon: <Iconify icon="eva:pie-chart-2-fill" sx={{ width: 1, height: 1 }} />,
  },

  { subheader: 'Data' },
  {
    title: 'baseline',
    path: '/measure/baseline',
    icon: <Iconify icon="eva:book-open-fill" sx={{ width: 1, height: 1 }} />,
  },
  {
    title: 'field data',
    path: '/measure/field-data',
    icon: <Iconify icon="eva:radio-fill" sx={{ width: 1, height: 1 }} />,
  },
  {
    title: 'spatial model',
    path: '/measure/spatial',
    icon: <Iconify icon="eva:layers-fill" sx={{ width: 1, height: 1 }} />,
  },

  { subheader: 'Tools' },
  {
    title: 'calibrations',
    path: '/measure/calibrations',
    icon: <Iconify icon="eva:sync-fill" sx={{ width: 1, height: 1 }} />,
  },
  {
    title: 'reports',
    path: '/measure/reports',
    icon: <Iconify icon="eva:file-text-fill" sx={{ width: 1, height: 1 }} />,
  },
];

export default navConfig;
